module.exports = __webpack_public_path__ + "media/images/aloe/illustrations/stripe-0d8a04b5b89e1ae7a16735e1f0d9106e.svg";